/**
 * User module
 * 用户数据模块
 */
import { Message } from "element-ui";
import {
	login,
	fetchPermissions,
	loginOut,
	changePatternRoom,
	fetchUserInfo,
	scanCodeLoginWithToken,
	secretLoginWidthToken
} from "@/api/user";
import i18n, { initI18n } from "@/i18n";
import router from "@/router";
import { flatPermissions } from "@/utils";

const state = {
	userInfo: {},
	permissions: [],
	token: "",
	initRoute: false
};

export default {
	namespaced: true,
	state,
	mutations: {
		SET_USERINFO(state, userInfo) {
			state.userInfo = userInfo;
		},
		SET_PERMISSIONS(state, permissions) {
			state.permissions = permissions;
		},
		SET_TOKEN(state, token) {
			state.token = token;
		},
		LOGIN_OUT(state) {
			state.userInfo = {};
			state.token = "";
			state.permissions = [];
		},
		SET_INIT_ROUTE(state, initRoute) {
			state.initRoute = initRoute;
		}
	},
	actions: {
		async getUserInfo({ commit }) {
			try {
				const res = await fetchUserInfo();

				if (res.code === 200) {
					commit("SET_USERINFO", res.data);
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(error);
			}
		},
		/**
		 * 用户登陆
		 * @param {Object} data
		 * @param {String} data.type 登陆类型 0:账号密码登陆 1:扫码登陆，2:中控携带token登陆
		 * @param {String} data.params 登陆参数
		 */
		async login({ commit, dispatch }, data) {
			try {
				const { type, params } = data;

				let loginApi;

				if (type === 0) {
					loginApi = login;
				} else if (type === 1) {
					loginApi = scanCodeLoginWithToken;
				} else if (type === 2) {
					loginApi = secretLoginWidthToken;
				}

				const res = await loginApi(params);

				if (res.code === 200) {
					commit("SET_TOKEN", res.data.access_token);
					localStorage.setItem("token", res.data.access_token);
					Message.success(i18n.tc("loginSuccess"));

					dispatch("getUserInfo");

					const nodeRes = await fetchPermissions();

					if (nodeRes.code === 200) {
						if (nodeRes.data.length === 0) {
							Message.error(i18n.tc("noPermissions"));
							router.push("/login");

							return;
						}

						const permissions = flatPermissions(nodeRes.data);

						commit("SET_PERMISSIONS", permissions);
						commit("SET_INIT_ROUTE", false);
						dispatch("common/setMenuMarkersCounts", null, { root: true });
						setTimeout(() => {
							router.push("/").then(() => {
								initI18n();
							});
						}, 200);
					}
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(error);
			}
		},
		async logout({ commit, state }) {
			try {
				await loginOut(state.token);
			} catch (error) {
				//
			} finally {
				commit("LOGIN_OUT");
				localStorage.removeItem("token");
				Message.success(i18n.tc("logoutSuccess"));
				setTimeout(() => {
					router.replace("/login");
				}, 200);
			}
		},
		/**
		 * 更改版房
		 * @param {Object} data
		 * @param {Number} data.pattern_room_id 版房id
		 */
		async changePatternRoom({ commit }, data) {
			try {
				const res = await changePatternRoom(data.pattern_room_id);

				if (res.code === 200) {
					commit("SET_TOKEN", res.data.access_token);
					localStorage.setItem("token", res.data.access_token);
					setTimeout(() => {
						// 重定向到根路由
						window.location.href = `${window.location.origin}${router.options.base}`;
					}, 50);
				}
			} catch (error) {
				//
			}
		},
		/**
		 * 获取权限节点数据
		 */
		async getPermissions({ commit }) {
			try {
				const { code, data } = await fetchPermissions();

				if (code === 200) {
					const permissions = flatPermissions(data);

					commit("SET_PERMISSIONS", permissions);
					commit("SET_INIT_ROUTE", false);
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(error);
			}
		}
	}
};
